import React from 'react'


const Default = ({title}) => {

  return (
    <div className='bg-white py-10 container rounded-b-2xl mb-20 border-terciaria border-t-0 border relative h-[109px]'>
      <p className='text-center text-terciaria text-3xl font-bold'>{title}</p>
      <hr className='absolute h-1 bg-terciaria bottom-0 w-1/3 left-1/2 -translate-x-1/2' />
    </div>
  )
}

export default Default
